module.exports = __webpack_public_path__ + "static/img/hero-8.ee98ce1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web-firehero/common/h5/imgs/hero-8.png
// module id = JhbH
// module chunks = 13